const debug             = false;
myApp.nativeUI.tray     = {};


//
// Tray Menu
myApp.nativeUI.tray.init = function () {
    if(debug) console.log('Construct Custom Tray');

    // Construct our Tray Element
    myApp.nativeUI.tray          = new nw.Tray({ title: 'Tray', icon: nw.App.manifest.window.icon });
    if( nw.App.manifest.display_name ) myApp.nativeUI.tray.tooltip  = nw.App.manifest.display_name;

    myApp.nativeUI.tray.on('click', function () {
        myApp.mainWindow.show();
        myApp.mainWindow.focus();
    });


    // Give it a menu
    let menu = new nw.Menu();

    //
    // Dev Only Item
    if(myApp.isSDKBuild) {
        menu.append(new nw.MenuItem({
            type: 'normal',
            label: 'Reload',
            click: function () {
                myApp.nativeUI.removeTray();
                chrome.runtime.reload();
            }
        }));
    }

    //
    // Standard Items
    if( nw.App.manifest.config.options !== undefined || nw.App.manifest.config.options === true ) {
        menu.append(new nw.MenuItem({
            type: 'normal',
            label: 'Options',
            click: function () {
                myApp.nativeUI.options.init();
            }
        }));
    }
    if( nw.global.licenses !== undefined ) {
        menu.append(new nw.MenuItem({
            type: 'normal',
            label: 'About',
            click: function () {
                myApp.nativeUI.about.init();
            }
        }));
    }
    menu.append(new nw.MenuItem({
        type: 'normal',
        label: 'Quit',
        click: function () {
            myApp.nw.App.closeAllWindows();
        }
    }));


    // Attach our menu to the tray element
    myApp.nativeUI.tray.menu = menu;
};


myApp.nativeUI.removeTray = function () {
    if(debug) console.log('Remove Custom Tray');

    if( myApp.nativeUI.tray !== undefined) {
        myApp.nativeUI.tray.remove();
        myApp.nativeUI.tray = null;
    }
};